export default __webpack_public_path__ + "static/media/logo.eb571110.svg";